module.exports = __webpack_public_path__ + "static/media/7en.4c3e0d3a.jpg";